/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  USAGE_STATISTICS_FETCHING,
  USAGE_STATISTICS_FETCHING_DONE,
  USAGE_STATISTICS_FETCHING_ERROR,
  UsageStatisticsActionType
} from 'store/action';
import {IUsageStatistics} from 'interfaces';
import {IPortalError} from 'utility/error-handler';

export interface IUsageStatisticsState {
  isFetching: boolean;
  error: null | IPortalError;
  usageStatistics: IUsageStatistics;
}

const defaultState = {
  isFetching: false,
  error: null,
  usageStatistics: null
};
const usageStatisticsReducer: Reducer<Readonly<IUsageStatisticsState>, UsageStatisticsActionType> = (
  state: IUsageStatisticsState = defaultState,
  action: UsageStatisticsActionType
) => {
  switch (action.type) {
    case USAGE_STATISTICS_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case USAGE_STATISTICS_FETCHING_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        usageStatistics: action.payload.data
      };
    }

    case USAGE_STATISTICS_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default usageStatisticsReducer;